@for (hotelBooking of hotelBookings; let last = $last; track hotelBooking) {
  <p [ngClass]="{ 'mb-2': !last }">
    Includes a hotel stay at <span data-id="name">{{ hotelBooking.name }}</span
    >&nbsp;
    <span data-id="dates">
      {{ hotelBooking.checkInDate | date: 'MMM d' }} –
      {{ hotelBooking.checkoutDate | date: 'MMM d' }}
    </span>
  </p>
}
